module.exports = __webpack_public_path__ + "img/WT-fontBack.a641166f.png";